import { Component, effect, inject, OnDestroy } from '@angular/core';
import { NonNullableFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FormValidators } from '@corelabs/angular/forms';
import { ButtonModule } from 'primeng/button';
import { FormInputComponent } from '@shared/forms';
import { UnavailableComponent } from '@shared/components';
import { AdminFacade } from '@app/store/admin';

@Component({
    selector: 'app-admin-edit-modal',
    templateUrl: './edit.component.html',
    styleUrls: ['./edit.component.css'],
    imports: [ReactiveFormsModule, TranslateModule, ButtonModule, FormInputComponent, UnavailableComponent],
})
export class EditComponent implements OnDestroy {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly adminFacade = inject(AdminFacade);
    private readonly formBuilder = inject(NonNullableFormBuilder);

    readonly admin = this.adminFacade.admin;
    readonly loading = this.adminFacade.loading;
    readonly saving = this.adminFacade.saving;
    readonly error = this.adminFacade.error;

    readonly form = this.formBuilder.group({
        firstName: this.formBuilder.control('', [FormValidators.Required, FormValidators.Text]),
        lastName: this.formBuilder.control('', [FormValidators.Required, FormValidators.Text]),
        email: this.formBuilder.control('', [FormValidators.Required, FormValidators.Email]),
    });

    constructor() {
        const id = this.route.parent?.snapshot.params['id'];
        if (id) {
            this.adminFacade.getAdmin(id);
        }

        effect(() => {
            const admin = this.admin();
            if (admin) {
                this.form.patchValue(admin);
            }
        });

        effect(() => {
            if (this.adminFacade.saved()) {
                this.close();
            }
        });

        effect(() => {
            if (this.adminFacade.saving() === false && this.adminFacade.saved() === false) {
                this.form.enable();
            }
        });
    }

    ngOnDestroy(): void {
        this.adminFacade.clear();
    }

    onSubmit(): void {
        this.form.markAllAsTouched();

        const admin = this.admin();
        if (this.form.valid && admin) {
            this.form.disable();
            this.adminFacade.updateAdmin(admin.id, this.form.getRawValue());
        }
    }

    close(): void {
        this.router.navigate([{ outlets: { modal: null } }]);
    }
}
